//@ts-strict-ignore
import { InfoButton } from '../../components/connectedForm/Button';
import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { openFormActionInNewTab } from '../../utils/CheckPopUpBlockerFunction';
import { IEntityActions } from '../../@types/entityTypes';
import { isNotArchived } from '../../components/connectedForm/HeaderBlock/HeaderBlock';
import { TaskPermission } from '../../graphql/entities/diary/DiaryEvent';

export const formActions: IEntityActions = [
  {
    description: 'Add Task',
    component: InfoButton,
    fn: addEvent,
    individualButton: true,
    actionReference: TaskPermission.Create,
    actionIgnore: true, //Exclude from 'customers' submenu. Display only against event.
  },
  {
    description: 'Add Purchase Order',
    component: InfoButton,
    fn: addPurchaseOrder,
    individualButton: true,
    actionReference: 'PURCHASING_ORDERS_CREATE',
    condition: isNotArchived,
  },
];

function addEvent(props) {
  const { values: supplier, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;

  openFormActionInNewTab(connectedForm.dispatch, `/Diary/Task/Details/New/Supplier/${supplier.id}`);
}

function addPurchaseOrder(props) {
  const { values: supplier, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;

  openFormActionInNewTab(connectedForm.dispatch, `/Purchasing/Order/Details/New/${supplier.id}`);
}
